import PubSub from './pubsub.js';
class CartRemoveButton extends HTMLElement {
  constructor() {
    super()

    this.addEventListener('click', this.handleClick.bind(this));
    this.pubsub = PubSub;

  }

  handleClick(e) {
    e.preventDefault();
    const cartItems = this.closest('cart-items');
    cartItems.updateQuantity(this.dataset.index, 0);
  }

  connectedCallback() {}
  disconnectedCallback() {}

}
typeof customElements.get('cart-remove-button') === 'undefined' ? customElements.define('cart-remove-button', CartRemoveButton) : null;

class CartItems extends HTMLElement {
  constructor() {
    super()

    this.pubsub = PubSub;
    this.isRerendering = false;

  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-icon-bubble',
        section: 'layout-header',
        selector: '.cart-item-count'
      },
      {
        id: 'cart-drawer',
        section: document.getElementById("cart-drawer").dataset.id,
        selector: '.js-contents'
      }
    ]
  }

  enableLoading(line) {
    // console.log("enableLoading on line: ", line);
    this.querySelector(`[data-index="${line}"]`).classList.add('opacity-40');
    this.querySelectorAll(`[data-index="${line}"] > button`).forEach((button) => {
      button.setAttribute('disabled', 'disabled');
    })
  }

  disableLoading(line) {
    // console.log("disableLoading on line: ", line);
    this.querySelector(`[data-index="${line}"]`).classList.remove('opacity-40');
    this.querySelectorAll(`[data-index="${line}"] > button`).forEach((button) => {
      button.removeAttribute('disabled');
    })
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleCartRerender(data) {
    if (this.isRerendering) return; // Prevent multiple calls
    this.isRerendering = true;

    // console.log("handleCartRerender: ", data);

    const sections = this.getSectionsToRender();

    const fetchPromises = sections.map(section => {
      return fetch(`${window.Shopify.routes.root}?section_id=${section.section}`)
        .then(response => response.text())
        .then(html => {
          const newContent = this.getSectionInnerHTML(html, section.selector);
          const container = document.querySelector(section.selector);
          if (container) {
            container.innerHTML = newContent;
          }
        })
        .catch(error => console.error('Error fetching section:', error));
    });

    Promise.all(fetchPromises).finally(() => {
      this.isRerendering = false; // Reset flag after all fetches complete
    });
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section).join(','), // 'header,cart-drawer',
      sections_url: window.location.pathname,
    });

    const updateQuantityAbortController = new AbortController();
    const updateQuantitySignal = updateQuantityAbortController.signal;

    fetch(window.Shopify.routes.root + 'cart/change.js', { updateQuantitySignal, ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.handleCartRerender(parsedState);

        // this.getSectionsToRender().forEach((section) => {
        //   const elementToReplace =
        //     document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        //   elementToReplace.innerHTML = this.getSectionInnerHTML(
        //     parsedState.sections[section.section],
        //     section.selector
        //   );
        // });
        
      })
      .catch((error) => {
        if (error.name === 'AbortError') {
          console.error("Request aborted: ", error);
        } else {
          console.error("Error: ", error);
        }
      })
      .finally(() => {
        this.disableLoading(line);
      });

      setTimeout(() => {
        updateQuantityAbortController.abort();
      }, 5000);
  }

  connectedCallback() {
    this.pubsub.sub('cart:rerender', this.handleCartRerender.bind(this));
  }
  disconnectedCallback() {
    this.pubsub.unsub('cart:rerender', this.handleCartRerender.bind(this));
  }

}
typeof customElements.get('cart-items') === 'undefined' ? customElements.define('cart-items', CartItems) : null;